export default {
  // sports (state) {
  //   return state.sports
  // },
  // countries (state) {
  //   //   return state.countries
  //   // },
  //   // genders (state) {
  //   //   return state.genders
  //   // },
  // ages (state) {
  //   return state.ages
  // },
  // partners (state) {
  //   return state.partners
  // },
  // roles (state)  {
  //   return state.roles
  // },
  reasons (state) {
    return state.reasons
  },
  abilities (state) {
    return state.abilities
  },
  watermarks (state) {
    return state.watermarks
  },
  sources (state) {
    return state.sources
  },
  restreamersServers (state) {
    return state.restreamersServers
  },
  reason: state => id => {
    return state.reasons.data.find(reason => reason.id === id)
  },
  bells: (state) => {
    return state.bells
  }
}
